module.exports = "/_next/static/images/img-proxy-voting-2d61a90cf703107599d20ef1a4af7704.svg";